import { Typography } from 'antd';
import { TitleProps } from 'antd/lib/typography/Title';
import { APP_COLORS, APP_SIZES } from 'constants/vars';
import { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';

const { Title } = Typography;

interface IProps extends Omit<HTMLAttributes<TitleProps>, 'size' | 'color'> {
  $color: keyof typeof APP_COLORS;
  $size: keyof typeof APP_SIZES;
  $fontWeight?: string;
  $textAlign?: string;
  $lineHeight?: number;
}

export const StyledTitle = styled(Title)<IProps>`
  ${({ $color, $fontWeight, $size, $textAlign, $lineHeight }) => css`
    &&& {
      color: ${APP_COLORS[$color]};
      margin-block: 0;
      text-align: ${$textAlign};
      line-height: ${$lineHeight};
      font-weight: ${$fontWeight};
      font-size: ${APP_SIZES[$size]};
    }
  `}
`;
